export default "__VITE_PUBLIC_ASSET__bc03d99e__"